var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStatusProcess = function SvgStatusProcess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.375V20H13.625",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 15.75C10.1041 15.75 7.25 12.8959 7.25 9.375C7.25 5.85409 10.1041 3 13.625 3C17.1459 3 20 5.85409 20 9.375C20 12.8959 17.1459 15.75 13.625 15.75ZM13.625 14.475C14.9776 14.475 16.2748 13.9377 17.2312 12.9812C18.1877 12.0248 18.725 10.7276 18.725 9.375C18.725 8.0224 18.1877 6.72519 17.2312 5.76876C16.2748 4.81232 14.9776 4.275 13.625 4.275C12.2724 4.275 10.9752 4.81232 10.0188 5.76876C9.06232 6.72519 8.525 8.0224 8.525 9.375C8.525 10.7276 9.06232 12.0248 10.0188 12.9812C10.9752 13.9377 12.2724 14.475 13.625 14.475ZM14.2625 9.375H16.8125V10.65H12.9875V6.1875H14.2625V9.375Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatusProcess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-process.f24aa7a7.svg";
export { ForwardRef as ReactComponent };